export const safeFetch = async (url, options = {}) => {
    const response = await fetch(url, options);
    const text = await response.text();

    try {
        // Find the first occurrence of { or [
        const jsonStartIndex = text.search(/\{|\[/);
        if (jsonStartIndex === -1) {
            throw new Error('No JSON found in response');
        }

        const jsonString = text.substring(jsonStartIndex);
        const jsonData = JSON.parse(jsonString);

        return {
            ok: response.ok,
            status: response.status,
            data: jsonData
        };
    } catch (error) {
        console.error('Failed to parse clean JSON:', error);
        console.error('Raw response was:', text);
        throw new Error('Invalid JSON response from server');
    }
};
